import { render, staticRenderFns } from "./LinkDeviationDelayTable.vue?vue&type=template&id=27ae3fa8"
import script from "./LinkDeviationDelayTable.vue?vue&type=script&lang=js"
export * from "./LinkDeviationDelayTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports